// src/shared/components/ui/Table.jsx
// ✅ جدول موحد — Modern Dark Ready
import React from 'react';
import styles from './Table.module.css';

/**
 * @param {Array}    columns     — [{ key, label, sortable?, render?, width? }]
 * @param {Array}    data        — مصفوفة الصفوف
 * @param {Object}   sortConfig  — { key, direction }
 * @param {Function} onSort      — (key) => void
 * @param {Function} onRowClick
 * @param {string}   emptyMessage
 * @param {boolean}  loading
 */
const Table = ({
  columns,
  data         = [],
  sortConfig,
  onSort,
  onRowClick,
  emptyMessage = 'لا توجد بيانات.',
  loading      = false,
}) => {
  const getSortIcon = (key) => {
    if (!sortConfig || sortConfig.key !== key) return ' ↕';
    return sortConfig.direction === 'asc' ? ' ↑' : ' ↓';
  };

  return (
    <div className={styles.wrapper}>
      <table className={styles.table}>

        {/* ── رأس الجدول ── */}
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.key}
                style={{ width: col.width }}
                className={col.sortable && onSort ? styles.sortable : ''}
                onClick={() => col.sortable && onSort?.(col.key)}
              >
                {col.label}
                {col.sortable && onSort && (
                  <span className={styles.sortIcon}>
                    {getSortIcon(col.key)}
                  </span>
                )}
              </th>
            ))}
          </tr>
        </thead>

        {/* ── الجسم ── */}
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={columns.length} className={styles.center}>
                جاري التحميل...
              </td>
            </tr>
          ) : data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className={styles.center}>
                {emptyMessage}
              </td>
            </tr>
          ) : (
            data.map((row, rowIndex) => (
              <tr
                key={row.id ?? rowIndex}
                onClick={() => onRowClick?.(row)}
                className={onRowClick ? styles.clickableRow : ''}
              >
                {columns.map((col) => (
                  <td key={col.key} data-label={col.label}>
                    {col.render
                      ? col.render(row[col.key], row, rowIndex)
                      : (row[col.key] ?? '-')}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;